/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountId,
  MapString,
  PublicOwnershipSchedulingLinkV2,
  PublicRoundRobinSchedulingLinkV2,
  ScheduleMeetingRequestV3,
  ScheduleMeetingResponseV3,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "team-scheduling";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkBySlugV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/round-robin-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findARoundRobinSchedulingLinkBySlugV3 = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      PublicRoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkBySlugV3 */
  findARoundRobinSchedulingLinkBySlugV3PathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/round-robin-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/round-robin-scheduling-links/{roundRobinSchedulingLinkId}
   * @secure
   */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV3 = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicRoundRobinSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV3 */
  findARoundRobinSchedulingLinkByRoundRobinSchedulingLinkIdPublicV3PathGetter = (
    tenantId: string,
    roundRobinSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v3/guest-external/tenant/${tenantId}/round-robin-scheduling-links/${roundRobinSchedulingLinkId}`,
    );

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkBySlugV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/ownership-scheduling-links/find-by-slug/{slug}
   * @secure
   */
  findAOwnershipSchedulingLinkBySlugV3 = (tenantId: string, slug: string, params: RequestParams = {}) =>
    this.request<
      PublicOwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkBySlugV3 */
  findAOwnershipSchedulingLinkBySlugV3PathGetter = (tenantId: string, slug: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/ownership-scheduling-links/find-by-slug/${slug}`);

  /**
   * No description
   *
   * @name FindAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/ownership-scheduling-links/{ownershipSchedulingLinkId}
   * @secure
   */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV3 = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
    params: RequestParams = {},
  ) =>
    this.request<
      PublicOwnershipSchedulingLinkV2,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV3 */
  findAOwnershipSchedulingLinkByOwnershipSchedulingLinkIdPublicV3PathGetter = (
    tenantId: string,
    ownershipSchedulingLinkId: string,
  ) =>
    this.getServicePath(
      `/v3/guest-external/tenant/${tenantId}/ownership-scheduling-links/${ownershipSchedulingLinkId}`,
    );

  /**
   * @description Returns a MeetingId if the request was accepted and Error otherwise
   *
   * @name ScheduleAMeetingV3GuestEndpoint
   * @request POST:/v3/guest-external/tenant/{tenantId}/meeting
   * @secure
   */
  scheduleAMeetingV3GuestEndpoint = (tenantId: string, data: ScheduleMeetingRequestV3, params: RequestParams = {}) =>
    this.request<
      ScheduleMeetingResponseV3,
      | AccountId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/meeting`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for scheduleAMeetingV3GuestEndpoint */
  scheduleAMeetingV3GuestEndpointPathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/meeting`);
}
